/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Exp_Mk_Hero_LeadInputs */

const es_exp_mk_hero_lead = /** @type {(inputs: Exp_Mk_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a una travesía con plazas libres o publica la tuya. Más días en el agua, más gente navegando, menos coste para todos.`)
};

const gl_exp_mk_hero_lead = /** @type {(inputs: Exp_Mk_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Súmate a unha travesía con prazas libres ou publica a túa. Máis días na auga, máis xente navegando, menos custo para todos.`)
};

const en_exp_mk_hero_lead = /** @type {(inputs: Exp_Mk_Hero_LeadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join a trip with spare places or publish yours. More days on the water, more people sailing, lower cost for everyone.`)
};

/**
* | output |
* | --- |
* | "Join a trip with spare places or publish yours. More days on the water, more people sailing, lower cost for everyone." |
*
* @param {Exp_Mk_Hero_LeadInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const exp_mk_hero_lead = /** @type {((inputs?: Exp_Mk_Hero_LeadInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Exp_Mk_Hero_LeadInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_exp_mk_hero_lead(inputs)
	if (locale === "en") return en_exp_mk_hero_lead(inputs)
	return es_exp_mk_hero_lead(inputs)
});